// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { useCallback } from 'react';
import { AxiosError } from 'axios';
import { questionnaire } from '../../apis/base';
import { questionnairePayload } from '../../types/Model';

export function sendQuestionnaire(payload: questionnairePayload): any {
  const result = questionnaire(payload)
    .then((response) => {
      // handle success case here
      return response.data;
    })
    .catch((error: AxiosError) => {
      const message = error.response?.data || 'Unhandled Error';
      // onError && onError(message);
      return message;
    })
  return result;
}
